export default __webpack_public_path__ + "static/media/full_compatibility_number.02b3ce92.svg";